import { TranslationKeys } from './locales';

export const en: TranslationKeys = {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    loading: 'Loading',
    noData: 'No data available',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    yearUnit: '',
    register: 'Register',
    casesUnit: 'cases',
  },
  
  login: {
    title: 'Login',
    id: 'User ID',
    password: 'Password',
    loginButton: 'Login',
    findId: 'Find ID',
    findPassword: 'Find Password',
    idPlaceholder: 'Please enter your ID.',
    passwordPlaceholder: 'Please enter your password.',
    keepLoggedIn: 'Keep me logged in',
    invalidCredentials: 'Account information is invalid. <br /> Please check your ID and password!',
  },
  
  dashboard: {
    title: 'Dashboard',
    farmMachineryCount: 'Farm Machinery on Map',
    totalMachinery: 'Total',
    unit: '',
    runningMachinery: 'Running',
    stoppedMachinery: 'Stopped',
    map: 'Map',
    list: 'List',
  },
  
  control: {
    title: 'Accident Control',
    farmMachineryOnMap: 'Farm Machinery on Map',
    searchPlace: 'Enter place or address',
    placeAddress: 'Place/Address',
    normal: 'Normal',
    cadastral: 'Cadastral',
    satellite: 'Satellite',
    eventDate: 'Event Date',
    deviceName: 'Device Name',
    owner: 'Owner',
    status: 'Status',
    running: 'Running',
    stopped: 'Stopped',
    noData: 'No data available',
    realtimeDetectionHistory: 'Real-time Detection History',
    farmMachineryList: 'Farm Machinery List',
    searchedFarmMachinery: 'Searched Farm Machinery',
    resultsPerPage: 'Results per page',
    realtimeOperationStatus: 'Real-time Operation Status',
    danger: 'Danger',
    caution: 'Caution',
    operating: 'Operating',
    notOperating: 'Not Operating',
    rolloverAccident: 'Rollover Accident',
    searchDeviceOwner: 'Search by device name or owner name',
    lastOperation: 'Last Operation',
    dangerAccident: 'Danger (Rollover Accident)',
    deviceList: 'Device List',
    noDeviceFound: 'No devices found',
    selectDetectionType: 'Select Detection Type',
    selectDeviceType: 'Select Device Type',
    totalFarmMachinery: 'Total Farm Machinery',
    checkDate: 'Please check the date.',
    selectBothDates: 'Please select both start date and end date.',
    group: 'Group',
    noRecord: 'No driving record',
    operationRecord: 'Operation Record',
    user: 'User',
    unlockRolloverStatus: 'Do you want to unlock the rollover status?',
    unlockRolloverContent: 'If unlocked, the accident detection status will be processed as normal.\nOnce processed as normal, cancellation is not possible.',
    confirmUnlock: 'Yes, unlock',
    openContact: 'Do you want to view the contact?',
    protectingPrivacy: 'We are protecting the lessee\'s personal information.',
    openLesseeContact: 'Do you want to view the lessee\'s contact?',
    openContactButton: 'View Contact',
    protectDevicePrivacy: (item: string) => `To protect the personal information of device ${item}`,
    enterOfficerName: 'Please enter the exact name of the officer viewing the contact.',
    accidentDetected: (minutes: number, seconds: number) => `[ ${minutes} minutes and ${seconds} seconds elapsed after accident detection ]`,
    farmMachineryUsageReport: 'Farm Machinery Usage Report',
    accidentDetectionRelease: 'Release Accident Detection',
    accidentDetectionReleaseReason: 'Please select the reason for releasing the detection',
    accidentDetectionReleaseReasonDesc: 'To understand the situation of the detected accident,\nplease select the exact reason for release.\nRelease information can be viewed in [Detection History].',
    accidentDetectionReleaseReasonDesc2: 'To understand the situation of the detected accident,',
    accidentDetectionReleaseReasonDesc3: 'please select the exact reason for release.\nRelease information can be viewed in [Detection History].',
    accidentDetectionReleaseButton: 'Release Detection',
    accidentOccurred: 'Accident Occurred',
    dangerousDriving: 'Dangerous Driving',
    areaExit: 'Area Exit',
    dangerousAreaEntry: 'Dangerous Area Entry',
    batteryLow: 'Low Battery',
    engineAbandonment: 'Engine Abandonment',
    rolloverAccidentDetected: 'A rollover accident has been detected.',
    checkUserSafetyImmediately: 'Please immediately check the user\'s safety!',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `${name}'s Farm Machinery Usage Report`,
    closeReportConfirm: 'Do you want to close the report?',
    deviceOperationStartDateMessage: 'The device operation start date has been retrieved.',
    currentLocationError: 'Unable to retrieve current location.',
    addressLookupError: 'Address lookup error:',
    ownedDeviceList: 'Owned Device List',
    recentOperationHistory: 'Recent Operation History',
    operationEndLocation: 'Operation End Location:',
    noRecentOperationHistory: 'No recent operation history.',
    viewMap: 'View Map',
    viewOperationHistory: 'View Operation History',
    operationRunning: 'Running',
    operationEnd: 'Operation End',
    // 소유자 정보 관련
    ownerInfo: 'Owner Information',
    ownerLabel: 'Owner',
    ownerContact: 'Owner Contact',
    currentLocation: 'Current Location',
    contactViewConfirm: 'Do you want to view the contact?',
    contactViewContent: (item: string) => `For the privacy protection of device ${item},\nplease enter the exact name of the person taking action.`,
    contactViewButton: 'View Contact',
    contactViewPlaceholder: 'Please enter the name of the person taking action.',
    // 운행 관련
    lastOperationTime: 'Last Operation',
    noOperationRecord: 'No Operation Record',
    // 차트 관련
    noDetectionInPeriod: 'No detection history in this period.',
    pleaseReselectDate: 'Please reselect the date.',
    // 기기 정보 모달 관련
    rentalPurpose: 'Rental Purpose',
    // 운행 기록 관련
    travelDistance: 'Travel Distance',
    farmMachineryVoltage: 'Farm Machinery Voltage',
    angle: 'Angle',
    addressUnavailable: 'Address unavailable.',
    operationLabel: 'Operation',
    degreeUnit: 'deg',
    currentStatus: 'Current Status',
    dailyInspectionRequiredMachineryList: 'Daily Inspection Required Machinery List',
    // 상태 관련
    statusNormal: 'Normal',
    statusCaution: 'Caution',
    statusDanger: 'Danger',
    vehicleRollover: 'Vehicle Rollover',
    // 기기 정보 관련
    deviceType: 'Device Type',
    // 감지 종류 (필터용)
    all: 'All',
    vehicleRolloverEvent: 'Vehicle Rollover',
    dangerousDrivingEvent: 'Dangerous Driving',
    engineAbandonmentEvent: 'Engine Abandonment',
    areaExitEvent: 'Area Exit',
    batteryLowEvent: 'Battery Low',
    theftDetection: 'Theft Detection',
    dangerousAreaEntryEvent: 'Dangerous Area Entry',
    // 기기 종류 (필터용)
    tractor: 'Tractor',
    speedSprayer: 'Speed Sprayer',
    fourWheelMotorcycle: 'Four-Wheel Motorcycle',
    twoWheelMotorcycle: 'Two-Wheel Motorcycle',
    oneTonTruck: '1-Ton Truck',
    walkingManagement: 'Walking Management',
    ridingManagement: 'Riding Management',
    agriculturalHighWorkVehicle: 'Agricultural High Work Vehicle',
    agriculturalTransportVehicle: 'Agricultural Transport Vehicle',
    agriculturalLoader: 'Agricultural Loader',
    ridingWeedCutter: 'Riding Weed Cutter',
    ridingWeedRemover: 'Riding Weed Remover',
    ridingTransplanter: 'Riding Transplanter',
    fertilizerSpreader: 'Fertilizer Spreader',
    pesticideSpreader: 'Pesticide Spreader',
    combine: 'Combine',
    excavator: 'Excavator',
    cultivator: 'Cultivator',
    branchCrusher: 'Branch Crusher',
    etc: 'Others',
  },
  
  history: {
    title: 'Detection History Inquiry',
    detectionTime: 'Detection Time',
    eventType: 'Event Type',
    deviceName: 'Device Name',
    owner: 'Owner',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    searchedDetections: 'Searched Detections',
    detectionNumber: 'Detection Number',
    deviceType: 'Device Type',
    deviceName2: 'Device Name',
    detectionDetails: 'Detection Details',
    detectedDateTime: 'Detected Date/Time',
    releasedDateTime: 'Released Date/Time',
    releaseReason: 'Release Reason',
    actionTakenBy: 'Action Taken By',
    detectionDetailView: 'Detection Detail View',
    noDataAvailable: 'No data found.',
    noLocationData: 'The location of this data cannot be determined.',
    downloadHistory: 'Download History',
    selectDeviceType: 'Select Device Type',
    selectDetectionType: 'Select Detection Type',
    searchDeviceOwner: 'Search device name or owner name',
    casesUnit: 'cases',
    lastOperation: 'Last Operation',
    distance: 'Distance',
    machineryVoltage: 'Machinery Voltage',
    currentStatus: 'Current Status',
    normal: 'Normal',
    detectionDetails2: 'Detection Details',
    detectionDateTime: 'Detection Date/Time',
    detectionLocation: 'Detection Location',
    releaseReason2: 'Release Reason',
    user2: 'User',
    userContact: 'User Contact',
    guardian: 'Guardian',
    guardianContact: 'Guardian Contact',
    guardianUserRelation: 'Guardian-User Relation',
    operating: 'Operating',
    deviceTypeLabel: 'Device Type',
  },
  
  manageUser: {
    title: 'User Management',
    userList: 'User List',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    register: 'Register Account',
    permissionManagement: 'Account Permission Management',
    cancelRegisterTitle: 'Cancel user registration?',
    cancelRegisterContent: 'Clicking confirm will reset the entered content.',
    userName: 'User Name',
    phone: 'Phone',
    email: 'Email',
    area: 'Group',
    grade: 'Grade',
    status: 'Status',
    searchUser: 'Search by user ID or name',
    userAccountInfo: 'User Account Information',
    myAccountInfo: 'My Account Information',
    confirmDelete: 'Do you want to delete this account?',
    deleteWarning: 'The user will no longer be able to use this account,\nand deleted account information cannot be recovered.',
    accountName: 'Account Name',
    userId: 'ID',
    contact: 'Contact',
    address: 'Address',
    detailAddress: 'Detail Address',
    accountCreationDate: 'Account Creation Date',
    viewDetails: 'View Details',
    viewContactRecord: 'View Contact Record',
    recordsFound: 'Records Found',
    category: 'Category',
    contactViewTime: 'Contact View Time',
    reader: 'Reader',
    deleteAccount: 'Delete Account',
    resetPassword: 'Reset Password',
    noDataFound: 'No data found.',
    deleteMessage: 'Are you sure you want to delete?',
    searchPlaceholder: 'Search',
    peopleUnit: 'people',
    // 추가 키들
    passwordConfirm: 'Password Confirmation',
    maxCharacters: 'Max 20 characters',
    passwordRequirements: '8+ characters including special characters',
    emailExample: 'e.g. test123@nongcall.com',
    phoneExample: 'e.g. 010-1234-1234 / 031-123-1234',
    postcodeSearch: 'Find Postcode',
    clear: 'Clear',
    accountNamePlaceholder: 'Enter organization name using control system (max 20 characters)',
    addressPlaceholder: 'Enter organization address using control system',
    userImageAlt: 'User Image',
    // 추가 placeholder 키들
    emailMaxCharacters: 'Max 50 characters',
    phoneIncludeDash: 'Include dash when entering',
    detailAddressMaxCharacters: 'Max 100 characters',
    // 권한 관리 섹션
    detectionNotification: 'Detection Status Notification',
    functionManagement: 'Function Management',
    dangerAccident: 'Danger (Accident)',
    warningDangerousArea: 'Warning (Entry into dangerous area)',
    batteryAbnormal: 'Battery abnormality',
    areaExit: 'Departure from usage area',
    detectionRelease: 'Detection release processing',
    deviceInfoModify: 'Device information modification',
    // Password reset
    resetPasswordTitle: 'Reset password?',
    resetPasswordContent: 'Password will be reset when you click confirm.',
    // Contact view modal
    openContact: 'Would you like to view the contact?',
    protectingPrivacy: "To protect the user's personal information,\nplease enter the exact name of the officer viewing.",
    openContactButton: 'View Contact',
    enterOfficerName: "Please enter the officer's name.",
    // Contact related display
    noContact: 'No Contact',
    viewContact: 'View Contact',
    // My page modal
    viewAccountInfo: 'Would you like to view account information?',
    enterPasswordForPrivacy: 'Please enter your account password\nfor personal information protection.',
    enterPasswordPlaceholder: 'Please enter your password.',
    confirming: 'Confirming...',
  },
  
  manageNok: {
    title: 'Additional Recipient Management',
    nokList: 'Additional Recipient List',
    addNok: 'Add Additional Recipient',
    editNok: 'Edit Additional Recipient',
    deleteNok: 'Delete Additional Recipient',
    nokName: 'Name',
    relationship: 'Relationship',
    phone: 'Phone',
    priority: 'Priority',
    // Additional recipient management page
    recipientInfo: 'Additional Notification Recipient Info',
    recipientContact: 'Additional\nRecipient Contact',
    ownerName: 'Owner Name',
    ownerContact: 'Owner Contact',
    accountCreationTime: 'Account Creation Time',
    viewDetailInfo: 'View Details',
    deleteAccount: 'Delete Account',
    searchPlaceholder: 'Search by recipient ID or name',
    registerRecipient: 'Register Additional Recipient',
    sortByName: 'Sort by Name',
    sortByContact: 'Sort by Recipient Contact',
    sortByOwnerName: 'Sort by Owner Name',
    sortByOwnerContact: 'Sort by Owner Contact',
    sortByRelationship: 'Sort by Relationship',
    sortByCreationTime: 'Sort by Creation Time',
    defaultSort: 'Default Order',
    deleteConfirmTitle: 'Delete this account?',
    deleteConfirmContent: 'This recipient information will no longer be available,\nand deleted information cannot be recovered.',
    noDataFound: 'No data found.',
    // Additional recipient registration/edit modal
    registerRecipientTitle: 'Register Additional Recipient',
    registerRecipientSubtitle: 'Select Owner',
    editRecipientTitle: 'Edit Additional Recipient',
    editRecipientSubtitle: 'Select Owner',
    cancelRegisterTitle: 'Cancel registration?',
    cancelRegisterContent: 'All entered information will be cleared.',
    selectOwner: 'Select Owner',
    nameLabel: 'Name',
    contactLabel: 'Contact',
    ownerLabel: 'Owner',
    relationshipLabel: 'Relationship',
    namePlaceholder: 'Recipient name',
    contactPlaceholder: 'Numbers only (min 10 digits)',
    relationshipPlaceholder: 'Enter relationship',
    contactMinLength: 'Contact must be at least 10 digits.',
    contactOnlyNumbers: 'Contact must be numbers only.',
    registerSuccess: 'Recipient registered successfully',
    peopleUnit: 'people',
    // Additional recipient detail/edit modal
    detailInfoTitle: 'Recipient Details',
    editInfoTitle: 'Edit Recipient Details',
    editSuccess: 'Recipient updated successfully',
    cancelEditTitle: 'Cancel editing recipient?',
    cancelEditContent: 'All entered information will be cleared.',
    editComplete: 'Update Complete',
    maxCharacters: 'Max 20 characters',
    includeDash: 'Include dash when entering.',
  },
  
  manageCustomer: {
    title: 'Customer Management',
    customerList: 'Customer List',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    deleteCustomer: 'Delete Customer',
    customerName: 'Customer Name',
    phone: 'Phone',
    memo: 'Memo',
    // Customer management page
    ownerInfo: 'Customer Information',
    ownerNumber: 'Customer\nNumber',
    contact: 'Contact',
    name: 'Name',
    address: 'Address',
    detailAddress: 'Detail Address',
    group: 'Group',
    viewDetailInfo: 'View Details',
    deleteAccount: 'Delete Account',
    searchPlaceholder: 'Search by Customer ID or Name',
    registerOwner: 'Register Customer',
    sortByNumber: 'Sort by Number',
    sortByContact: 'Sort by Contact',
    sortByName: 'Sort by Name',
    sortByAddress: 'Sort by Address',
    sortByDetailAddress: 'Sort by Detail Address',
    sortByGroup: 'Sort by Group',
    defaultSort: 'Default Sort',
    deleteConfirmTitle: 'Delete this account?',
    deleteConfirmContent: 'The customer will no longer be able to use this account,\nand deleted account information cannot be recovered.',
    noDataFound: 'No data found.',
    peopleUnit: 'people',
    casesUnit: 'cases',
    noAddress: 'No Address',
    noGroup: 'No Group',
    noDetailAddress: 'No Detail Address',
    detailAddressLabel: 'Detail Address',
    // Customer detail modal
    detailInfoTitle: 'Customer Details',
    editInfoTitle: 'Edit Customer',
    ownerName: 'Customer Name',
    ownerContact: 'Customer Contact (ID)',
    password: 'Password',
    joinDate: 'Join Date',
    other: 'Other',
    groupLabel: 'Group',
    // Customer modify modal
    modifyInfoTitle: 'Edit Customer Details',
    modifyComplete: 'Edit Complete',
    cancelModifyTitle: 'Cancel customer edit?',
    cancelModifyContent: 'Your input will be reset when you click confirm.',
    invalidPassword: 'Invalid password.',
    passwordSpaceError: 'Password cannot contain spaces.',
    passwordRequirements: 'Must include at least one letter, number, and special character,\nand be at least 8 characters long.',
    maxCharacters20: 'Max 20 characters',
    maxCharacters100: 'Max 100 characters',
    includeDash: 'Include dashes when entering.',
    addressPlaceholder: 'Address',
    passwordPlaceholder: 'Letters, numbers, special characters, 8+ characters',
    groupSrLabel: 'Organization',
    // 연락처 관련
    noContact: 'No Contact',
    viewContact: 'View Contact',
    // Customer register modal
    registerInfoTitle: 'Register Customer',
    registerComplete: 'Register',
    cancelRegisterTitle: 'Cancel customer registration?',
    cancelRegisterContent: 'Your input will be reset when you click confirm.',
    registerSuccess: 'Customer registration successful',
    numbersOnly: 'Please enter numbers only.',
    otherPlaceholder: 'Other input',
    noDashNumbers: 'Numbers only without dashes',
  },
  
  manageMobility: {
    title: 'Farm Machinery Management',
    mobilityList: 'Farm Machinery List',
    addMobility: 'Add Farm Machinery',
    mobilityName: 'Machinery Name',
    mobilityType: 'Machinery Type',
    owner: 'Owner',
    status: 'Status',
  },
  
  mobileList: {
    title: 'Farm Machinery Management',
    searchDeviceOwner: 'Search by device name or owner name',
    from: 'From',
    to: 'To',
    selectDeviceType: 'Select Device Type',
    selectDetectionType: 'Select Detection Type',
    group: 'Group',
    registerDevice: 'Register Device',
    searchedDevices: 'Searched Devices',
    unit: '',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    owner: 'Owner',
    operationStatus: 'Operation\nStatus',
    lastOperationDate: 'Last Operation\nDate/Time',
    terminalSN: 'Terminal\nS/N',
    machineryBattery: 'Machinery\nBat',
    terminalBattery: 'Terminal\nBat',
    testMode: 'Inspection\nMode',
    deviceDetail: 'Device Details',
    viewOnMap: 'View on Map',
    deviceDelete: 'Delete Device',
    testModeActivate: 'Do you want to change the mode status?',
    testModeDeactivate: 'Do you want to deactivate inspection mode?',
    testModeActivateContent: 'If you change to inspection mode,\nyou will not be able to receive accident notifications for this device,\nand you can receive them again after inspection mode is deactivated.',
    testModeDeactivateContent: 'If you deactivate inspection mode,\nthe device may generate accident notifications.',
    deleteDevice: 'Do you want to delete this device?',
    deleteDeviceContent: 'If you delete the device, you will not be able to view its information,\nand deleted device information cannot be recovered.',
    confirmDelete: 'Delete',
    exportInstallHistory: 'items export installation history',
    exportCount: 'items',
    noRecord: 'No driving record',
    inspectionNeeded: 'Device inspection is needed.',
    clipboardCopied: 'Copied to clipboard.',
    noDownloadAvailable: 'No file available for download.',
    downloadSuccess: 'File download successful',
  },
  
  deviceRegister: {
    title: 'Register Device',
    deviceName: 'Device Name',
    deviceNamePlaceholder: 'Max 20 characters',
    owner: 'Owner',
    ownerPlaceholder: 'Please select an owner',
    selectOwner: 'Owner',
    deviceType: 'Device Type',
    terminalSerialNumber: 'Terminal Serial Number',
    terminalSerialPlaceholder: 'Min 8 characters ~ Max 16 characters',
    terminalIMEI: 'Terminal IMEI',
    terminalIMEIPlaceholder: '15 digits',
    numbersOnly: 'Numbers only.',
    confirmRegister: 'Do you want to register the device?',
    confirmRegisterContent: 'The registered content can be modified later.',
    confirmRegisterButton: 'Register',
    cancelRegister: 'Do you want to cancel device registration?',
    cancelRegisterContent: 'If you confirm, the entered content will be reset.',
    checkInput: 'Please check your input again.',
    registerCancel: 'Cancel',
    registerButton: 'Register',
    registerLoading: 'Registering',
    noRegisterButton: 'Register',
    ownerRequired: 'Please select an owner.',
    ownerError: 'This data cannot be selected.',
    imageUploadSuccess: 'User image uploaded successfully',
    imageUploadError: 'An error occurred while registering the image.',
    bulkUploadTitle: 'Please upload the device information Excel file.',
    bulkUploadContent: 'Please upload an Excel file with device registration information.\nFor accurate device registration, please use only files formatted according to the template.',
  },
  
  deviceDetail: {
    title: 'Device Information Details',
    titleEdit: 'Edit Device Information',
    deviceName: 'Device Name',
    owner: 'Owner',
    ownerPlaceholder: 'Please select an owner',
    ownerSelect: 'Owner',
    registrationDate: 'Device Registration Date/Time',
    deviceType: 'Device Type',
    terminalSerialNumber: 'Terminal Serial Number',
    terminalIMEI: 'Terminal IMEI',
    modifyDevice: 'Edit',
    modifyComplete: 'Complete',
    cancelModify: 'Do you want to cancel editing device information?',
    cancelModifyContent: 'If you confirm, the edited content will be reset.',
    ownerRequired: 'Please select an owner.',
    ownerError: 'This data cannot be selected.',
    numbersOnly: 'Numbers only.',
    save: 'Save',
    reset: 'Cancel',
    installPhotos: 'Installation Photos',
    overallView: 'Overall View',
    terminalInstallation: 'Terminal Installation',
    terminalSerialSticker: 'Terminal Serial Sticker',
    powerWiringStatus: 'Power Wiring Status',
    machineryTypePlate: 'Machinery Type Plate',
    userPhoto: 'User Photo',
    noImage: 'No image available.',
  },
  
  eventTypes: {
    accident: 'Accident',
    battery: 'Battery Low',
    dangerous: 'Dangerous Area Entry',
    userArea: 'Off Limits',
    emergency: 'Emergency Call',
    keyOn: 'Idle',
  },
  
  status: {
    normal: 'Normal',
    warning: 'Warning',
    error: 'Error',
    running: 'Running',
    stopped: 'Stopped',
    idle: 'Idle',
  },
  
  navigation: {
    home: 'Home',
    accidentControl: 'Accident Control',
    detectionHistory: 'Detection History',
    statistics: 'Statistics',
    notice: 'Notice',
    management: 'Management',
    farmMachineryManagement: 'Farm Machinery Management',
    userAccountManagement: 'User Account Management',
    ownerManagement: 'Owner Management',
    additionalRecipientManagement: 'Additional Recipient Management',
    sitemap: 'Sitemap',
    logout: 'Logout',
    honorific: '',
  },
  
  notice: {
    title: 'Notice',
    goBack: 'Back to List',
    confirm: 'Confirm',
    edit: 'Edit',
    editContent: 'Edit Content',
    delete: 'Delete',
    deleteTitle: 'Do you want to delete the notice?',
    deleteContent: 'Deleted notices will not be displayed to owners and cannot be restored.',
    register: 'Register Notice',
    noNotice: 'No registered notices.',
    previousNotice: 'Previous Notice',
    nextNotice: 'Next Notice',
    new: 'New',
    web: 'WEB',
    app: 'APP',
    write: 'Write Notice',
    editTitle: 'Edit Notice',
    category: 'Notice Category',
    noticeTitle: 'Notice Title',
    titlePlaceholder: 'Enter title (max 100 characters)',
    cancel: 'Cancel',
    complete: 'Complete',
    registerConfirm: 'Do you want to register the notice?',
    registerContent: 'Notice content can be edited or deleted,\nand registered notices can be viewed by owners.',
    cancelConfirm: 'Do you want to go back to the list?',
    cancelContent: 'If you click confirm,\nthe content written so far will not be saved.',
    editBreadcrumb: 'Edit Notice',
    detailBreadcrumb: 'Notice Detail',
    contentPlaceholder: 'Please enter the body content (max 2000 characters)',
    imageFormatInfo: '* Attachable image file formats are png, jpg, jpeg.',
    imageSizeInfo: '* The size limit for one image file is 5MB, and up to 5 files can be attached.',
    maxLengthExceeded: 'Exceeds 2000 characters.',
    invalidFileFormat: 'Please check the file format.\nUploadable file formats are png, jpg, jpeg.',
    maxImagesExceeded: 'You can attach up to 5 images maximum.',
    maxSizeExceeded: 'Each image file is limited to 5MB maximum.',
    confirmTitle: 'Please check the content.',
  },
  
  statistics: {
    title: 'Detection History Statistics',
    search: 'Search',
    download: 'Download',
    invalidPeriod: 'Please select a period of\n7 days or more.',
    noData: 'No records found for this period.\nPlease select different dates.',
    monthView: 'View by Month',
    operatedMachinery: 'Operated Agricultural Machinery',
    totalMachinery: 'Total Agricultural Machinery',
    dailyDetections: 'Daily Detection History (cases)',
    periodDetections: 'Detection History within Period (%)',
    hourlyDetections: 'Hourly Detection History (cases)',
    detectByType: 'Detection History by Type',
    detectList: 'Detection History List',
    totalDetections: 'Total Detections',
    rolloverDetections: 'Rollover Accident Detections',
    dangerousDrivingDetections: 'Dangerous Driving Detections',
    outOfAreaDetections: 'Out of Area Detections',
    batteryAnomalyDetections: 'Battery Anomaly Detections',
    ignitionNeglectDetections: 'Ignition Neglect Detections',
    cases: 'cases',
    units: 'units',
    selectPeriod: 'Select Period',
    selectPeriodPlaceholder: '-- Select Period --',
    oneMonth: '1 Month',
    threeMonths: '3 Months',
    sixMonths: '6 Months',
    oneYear: '1 Year',
    timeUnit: '(Unit: Hours)',
    monthlyDetections: 'Monthly Detection History (cases)',
    dailyView: 'View by Day',
    detectionHistory: 'Detection History',
    dayOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dangerousAreaEntryDetections: 'Dangerous Area Entry Detections',
    user: 'User',
    lastOperation: 'Last Operation',
    noDrivingRecord: 'No Driving Record',
  },
};

